/* @flow */
export function composeMultipleCells(generators: Function[]): React.Node {
  return (input: Object) => {
    return generators.map(generator => generator(input));
  };
}
